import { render, staticRenderFns } from "./modal_form.vue?vue&type=template&id=03c0046e&"
import script from "./modal_form.vue?vue&type=script&lang=js&"
export * from "./modal_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03c0046e')) {
      api.createRecord('03c0046e', component.options)
    } else {
      api.reload('03c0046e', component.options)
    }
    module.hot.accept("./modal_form.vue?vue&type=template&id=03c0046e&", function () {
      api.rerender('03c0046e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/components/modal_form.vue"
export default component.exports